import { render, staticRenderFns } from "./AddressHistoryModal.vue?vue&type=template&id=087eff45&scoped=true"
import script from "./AddressHistoryModal.vue?vue&type=script&lang=js"
export * from "./AddressHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./AddressHistoryModal.vue?vue&type=style&index=0&id=087eff45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087eff45",
  null
  
)

export default component.exports